
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { LinkGrid } from '../../app/components';
import { links } from '../../__configuration__/style';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* KEYWORDS: style typography iconography color palette guide theme illustration icons */
    }
    <h1>{`Style Guide`}</h1>
    <p>{`Brightlayer UI has a wide variety of style resources to help ensure consistency across applications and make designing and building them easier.`}</p>
    <LinkGrid links={links} style={{
      marginTop: 32
    }} mdxType="LinkGrid" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;